import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import _, { set, times, wrap } from 'lodash';
import { fetchPromotionById, fetchPromotions } from "../../../services/promotions";
import StarPrivilegeTag from '../../../svgs/StarPrivilegeTag';
import PremiumPrivilegeTag from '../../../svgs/PremiumPrivilegeTag';

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [searchParams, setSearchParams] = useSearchParams();
    const data = props.data


    // const [promotionList, setPromotionList] = useState([])
    // async function fetchPromotionList() {
    //     let res = await fetchPromotions({  }, { limit: 999 }, { name: 1 })
    //     if (res.errno) return
    //     if (res.result)
    //         setPromotionList(res.result)
    // }
    // useEffect(() => {
    //     fetchPromotionList()
    // }, [])
    const [promotionArray, setPromotionArray] = useState([])
    async function fetchPromotionsArray() {
        let promotions = []
        if (data.promotions) {
            for (let p of (data.promotions || [])) {
                let pp = await fetchPromotionById(p)
                if (pp?.result)
                    promotions.push(pp?.result)
            }
            setPromotionArray(promotions)
        }
    }
    useEffect(() => {
        fetchPromotionsArray()
    }, [data])





    return (
        <div className="relative h-full w-full flex flex-col items-center justify-start bg-[#999] p-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className="w-[430px] border-[4px] border-[#666] rounded-[16px] " style={{ backgroundColor: "#F3F8FB" }}>

                <div className='relative w-full' style={{ borderTopLeftRadius: 16, borderTopRightRadius: 16, overflow: 'hidden' }}>
                    <img src={data?.hero || ''} className='w-full' style={{ objectFit: 'cover', height: 299 }} />
                </div>

                <div className='bg-[#F3F8FB] w-full'>

                    <div className='w-full pl-[16px] my-[20px]'>

                        <div className='text-[#6E604C] text-[16px] font-[500]'>相關優惠</div>
                        <div className='w-full mt-[12px]'>
                            <div style={{ overflowX: 'auto' }} className='w-full max-w-[100%] flex flex-row items-center justify-start'>
                                {promotionArray.map((item, index) =>
                                    <div style={{ width: 232, minWidth: 232, marginBottom: 24 }} className='relative flex-col flex flex-col items-center mr-[12px] border border-white border-2 rounded-xl' key={item?._id || index}>
                                        {/* <div className='absolute top-0 left-0 h-full w-full rounded-xl' style={{ overflow: 'hidden',background:'gradient()' }}  /> */}
                                        {/* <LinearGradient colors={['#E6EBED', '#E6EBED', '#E6EBED', '#FFFFFF']} className='absolute top-0 left-0 h-full w-full rounded-xl' style={{ overflow: 'hidden' }} /> */}
                                        <div className='absolute bottom-0 left-0 right-0 top-0 rounded-xl' style={{ background: 'linear-gradient(180deg, #FFFFFF10 70%, #FFFFFF 100%)' }} />
                                        {item.thumbnail ? <img src={item?.thumbnail} className='w-full rounded-xl z-[1]' style={{ objectFit: 'cover', height: 129 }} />
                                            : <img src={item?.img} className='w-full rounded-xl' style={{ objectFit: 'cover', height: 129 }} />}
                                        <div className='relative w-full flex flex-col z-[1]'>
                                            <div className=''>
                                                {item.subLabel && <div className='px-[8px] pt-[4px] text-[#949494] text-[10px] font-normal'>{item.subLabel}</div>}
                                                <div className='px-[8px] text-black text-[12px] py-[8px] font-normal mb-[4px]'>{item.name || item?.label || '-'}</div>
                                            </div>
                                        </div>
                                        {item.remaining && <div className='absolute bottom-0 left-1 text-[10px] text-[#949494] ml-[4px] z-[1]'>剩餘 {item.remaining} 天</div>}
                                        {(item?.isStarPrivilege|| item?.isPremiumPrivilege) && <div className='absolute left-1 top-1 w-full z-[1] flex flex-col gap-[4px]'>
                                            {item?.isStarPrivilege&&<StarPrivilegeTag />}
                                            {item?.isPremiumPrivilege&&<PremiumPrivilegeTag />}
                                        </div>}
                                    </div>)
                                }

                            </div>
                        </div>
                        <div className='absolute bottom-0 left-0 h-full w-full rounded-xl z-[2px]' style={{ background: 'linear-gradient(90deg, rgba(230, 235, 237, 1) 0%, #FFFFFF 100%);' }} />
                    </div>
                </div>
                <div className='relative pt-[38px]'>
                    <div className='px-[16px]'>
                        <div className='text-[#6E604C] text-[13px] font-[300] mb-[12px]'>商戶優惠券</div>
                        {/* {couponArray.length===0||<DiscountAction data={couponArray?.slice(0,2)} navigation={navigation} partnerId={route?.params?._id}/>}
                        {couponArray.length!==0 && isAllCouponOpen && <DiscountAction data={couponArray?.slice(2)} navigation={navigation} partnerId={route?.params?._id}/>} */}
                    </div>
                    {/* {couponArray.length===0||<TouchableOpacity onPress={() => setIsAllCouponOpen(!isAllCouponOpen)} className='flex flex-row items-center justify-around'>
                        <View className='w-[27%] h-[1px] bg-[#938474]'></View>
                        <View className='flex flex-row items-center justify-center'>
                            <Text className='text-[#938474] text-[12px] mr-[4px]'>{isAllCouponOpen?'折疊優惠券':'展開所有優惠券'}</Text>
                            {isAllCouponOpen?<GoldUpSvg/>:<GoldDownSvg />}
                        </View>
                        <View className='w-[27%] h-[1px] bg-[#938474]'></View>
                    </TouchableOpacity>} */}
                    <div className='flex flex-row items-center justify-between mt-[24px]'>
                        <div className='w-[64px] h-[1px] bg-[#938474]' />
                        <div className='text-[12px] text-[#938474]'>暫未開放</div>
                        <div className='w-[64px] h-[1px] bg-[#938474]' />
                    </div>
                </div>
                <div className='h-[9px] w-full bg-[#00000010] mt-[16px] mb-[20px]'></div>
                <div className='px-[16px] flex-col'>
                    <div className='text-[18px] text-[#6E604C] font-[600]'>{data?.contentTitle || "-"}</div>
                    <div className='mt-[16px] flex-col w-full'>
                        {data?.content?.map((c, ci) =>
                            c.type === 'text' ? <div key={ci} className='my-[8px]' style={{ color: c?.isTitle ? '#6E604C' : "#473F3A", fontWeight: c?.isTitle ? 700 : 400, fontSize: c?.isTitle ? 18 : 12, whiteSpace: 'pre-line',textAlign:'justify' }}>{c?.data || ''}</div>
                                : c.type === 'image' ?
                                    <div key={ci} className='w-full flex flex-row' style={{ justifyContent: c?.justifyContent || 'center', width: '100%' }}>
                                        <img src={c?.url} className='my-[16px]' style={{ objectFit: 'cover', height: undefined, aspectRatio: c.aspectRatio || (389 / 204), width: c.width || '100%' }} />
                                    </div>
                                    : <div key={ci} />
                        )}
                    </div>
                </div>
                <div className='px-[16px] my-[23px] flex flex-row items-center justify-between'>
                    <div className='text-[16px] text-[#6E604C]'>條款及細則</div>
                    <TncArrowSvg />
                </div>
                <div className='w-full h-[1px] bg-[#6E604C]'></div>
                <div className='px-[16px] mt-[25px] flex-col'>
                    {data?.termsAndConditions?.map((c, ci) =>
                        c.type === 'text' ? <div key={ci} className='text-[#473F3A] text-[12px]' style={{ whiteSpace: 'pre-line',textAlign:'justify' }}>{c?.data || ''}</div>
                            : c.type === 'image' ? <img key={ci} src={c?.url} className='w-full my-[16px]' style={{ objectFit: 'contain', height: undefined, aspectRatio: c.aspectRatio || (389 / 204) }} />
                                : <div key={ci} />
                    )}
                </div>
                <div className='w-full h-[250px]' />
            </div>
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)


const TncArrowSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={19}
        height={13}
        fill="none"
        {...props}
    >
        <path
            stroke="#8D876C"
            strokeLinecap="round"
            strokeWidth={2}
            d="m1.943 1.212 6.813 9.689a1 1 0 0 0 1.636 0l6.812-9.689"
        />
    </svg>
)